export const GET_MARKETING_CATEGORIES_PENDING = 'GET_MARKETING_CATEGORIES_PENDING';
export const GET_MARKETING_CATEGORIES_FULFILLED = 'GET_MARKETING_CATEGORIES_FULFILLED';
export const GET_MARKETING_CATEGORIES_REJECTED = 'GET_MARKETING_CATEGORIES_REJECTED';
export const GET_ADMIN_MARKETING_CATEGORIES_PENDING = 'GET_ADMIN_MARKETING_CATEGORIES_PENDING';
export const GET_ADMIN_MARKETING_CATEGORIES_FULFILLED = 'GET_ADMIN_MARKETING_CATEGORIES_FULFILLED';
export const GET_ADMIN_MARKETING_CATEGORIES_REJECTED = 'GET_ADMIN_MARKETING_CATEGORIES_REJECTED';
export const UPDATE_ADMIN_MARKETING_CATEGORIES_PENDING = 'UPDATE_ADMIN_MARKETING_CATEGORIES_PENDING';
export const UPDATE_ADMIN_MARKETING_CATEGORIES_FULFILLED = 'UPDATE_ADMIN_MARKETING_CATEGORIES_FULFILLED';
export const UPDATE_ADMIN_MARKETING_CATEGORIES_REJECTED = 'UPDATE_ADMIN_MARKETING_CATEGORIES_REJECTED';
export const DELETE_ADMIN_MARKETING_CATEGORY_PENDING = 'DELETE_ADMIN_MARKETING_CATEGORY_PENDING';
export const DELETE_ADMIN_MARKETING_CATEGORY_FULFILLED = 'DELETE_ADMIN_MARKETING_CATEGORY_FULFILLED';
export const DELETE_ADMIN_MARKETING_CATEGORY_REJECTED = 'DELETE_ADMIN_MARKETING_CATEGORY_REJECTED';

export default function marketingCategoriesReducer(state = {
  fetching: false,
  fetched: false,
  errors: {},
  marketingCategories: []
}, action) {
  switch (action.type) {
    case GET_MARKETING_CATEGORIES_PENDING:
    case UPDATE_ADMIN_MARKETING_CATEGORIES_PENDING:
    case GET_ADMIN_MARKETING_CATEGORIES_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_MARKETING_CATEGORIES_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        marketingCategories: Object.entries(action.payload).map(([id, name]) => ({ id: +id, name }))
      };
    }
    case UPDATE_ADMIN_MARKETING_CATEGORIES_FULFILLED:
    case GET_ADMIN_MARKETING_CATEGORIES_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        marketingCategories: action.payload.data
      };
    }
    case GET_MARKETING_CATEGORIES_REJECTED:
    case UPDATE_ADMIN_MARKETING_CATEGORIES_REJECTED:
    case GET_ADMIN_MARKETING_CATEGORIES_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case DELETE_ADMIN_MARKETING_CATEGORY_FULFILLED: {
      const newMarketingCategories = [...state.marketingCategories];

      return {
        ...state,
        marketingCategories: newMarketingCategories.filter(marketingCategory => marketingCategory.id !== action.payload)
      };
    }
    default: return { ...state };
  }
}
